import { useRTE } from '@pickleballinc/ui/components/global/RTEProvider';
import { useEffect, useState } from 'react';

import MatchLogs from '@/modules/results/match/MatchLogs';
import { Log, Player } from '@/modules/results/types';

interface MatchLogsLiveProps {
  matchUuid: string;
  isMatchLive?: boolean;
  utcOffset: number;
  timezoneAbbreviation: string;
  playerList: Player[];
  initialLogs: Log[];
}

const MatchLogsLive = ({
  matchUuid,
  initialLogs,
  playerList,
  utcOffset,
  timezoneAbbreviation,
  isMatchLive,
}: MatchLogsLiveProps) => {
  const { logs } = useRTE();

  const [logsData, setLogsData] = useState<Log[]>([]);

  useEffect(() => {
    setLogsData(initialLogs);
  }, [initialLogs]);

  useEffect(() => {
    const matchIndex = logs.findIndex((log) => log.match_uuid === matchUuid);

    if (matchIndex !== -1) {
      const matchToUpdate = logs[matchIndex];
      const newLogs = (matchToUpdate?.logs as Log[]) || [];
      if (newLogs.length > 0) {
        setLogsData(structuredClone([...initialLogs, ...newLogs]));
      }
    }
  }, [logs]);

  return (
    <MatchLogs
      isMatchLive={isMatchLive}
      logs={logsData}
      playerList={playerList}
      utcOffset={utcOffset}
      timezoneAbbreviation={timezoneAbbreviation}
    />
  );
};

export default MatchLogsLive;
